<!--
account/account.vue
-->
<template>
    <div class="s-taxes">

                <b-form-checkbox v-show="true" switch :size="chkSize" v-model="displayTaxF">{{getActiveTaxes.nameF}} <span class="txRate">({{getActiveTaxes.taxes_rate[0].rateF}}%)</span></b-form-checkbox>
                <b-form-checkbox v-show="true" switch :size="chkSize" v-model="displayTaxP">{{getActiveTaxes.nameP}} <span class="txRate">({{getActiveTaxes.taxes_rate[0].rateP}}%)</span></b-form-checkbox>
                <b-form-checkbox v-show="true" switch :size="chkSize" v-model="displayTaxFInclude">{{getActiveTaxes.nameF + ' ' + $t('tax_Incluse')}} <span class="txRate">({{getActiveTaxes.taxes_rate[0].rateF}}%)</span></b-form-checkbox>
                <b-form-checkbox v-show="true" switch :size="chkSize" v-model="displayTaxPInclude">{{getActiveTaxes.nameP + ' ' + $t('tax_Incluse')}} <span class="txRate">({{getActiveTaxes.taxes_rate[0].rateP}}%)</span></b-form-checkbox>
                <b-form-checkbox v-show="true" switch :size="chkSize" v-model="displayTaxMotel">{{$t('tax_TaxeDhebergement')}} <span class="txRate">({{getActiveTaxes.taxes_rate[0].rateMotel}}%)</span></b-form-checkbox>
                <b-form-checkbox v-show="true" switch :size="chkSize" v-model="displayTaxTire">{{$t('tax_Pneu')}} <span class="txRate">({{getActiveTaxes.taxes_rate[0].rateTire}}%)</span></b-form-checkbox>

    </div>
</template>

<script>

import {mapGetters} from 'vuex'

export default{
    name: "s-taxes",
    props: ['taxF', 'TaxFInclude', 'taxP', 'taxPInclude', 'taxMotel', 'taxTire'],
    data: function() {
        return {
            chkSize: this.getCheckSize
        }
    },
    methods:{

    },
    computed: {
        ...mapGetters(['getCheckSize', 'getActiveTaxes']),
        displayTaxF: {
            get: function() {
                let sendValue = this.taxF
                return sendValue
                },
            set: function(modifiedValue) {
                let newValue = modifiedValue
                this.$emit('update:taxF', newValue)
            }
        },
        displayTaxP: {
            get: function() {
                let sendValue = this.taxP
                return sendValue
                },
            set: function(modifiedValue) {
                let newValue = modifiedValue
                this.$emit('update:taxP', newValue)
            }
        },
        displayTaxFInclude: {
            get: function() {
                let sendValue = this.taxFInclude
                return sendValue
                },
            set: function(modifiedValue) {
                let newValue = modifiedValue
                this.$emit('update:taxFInclude', newValue)
            }
        },
        displayTaxPInclude: {
            get: function() {
                let sendValue = this.taxPInclude
                return sendValue
                },
            set: function(modifiedValue) {
                let newValue = modifiedValue
                this.$emit('update:taxPInclude', newValue)
            }
        },
        displayTaxMotel: {
            get: function() {
                let sendValue = this.taxMotel
                return sendValue
                },
            set: function(modifiedValue) {
                let newValue = modifiedValue
                this.$emit('update:taxMotel', newValue)
            }
        },
        displayTaxTire: {
            get: function() {
                let sendValue = this.taxTire
                return sendValue
                },
            set: function(modifiedValue) {
                let newValue = modifiedValue
                this.$emit('update:taxTire', newValue)
            }
        }
    }
}


</script>

<style lang="scss" scoped>

</style>